import { render } from "./ProjectsBlock.vue?vue&type=template&id=3b21ff87&scoped=true"
import script from "./ProjectsBlock.vue?vue&type=script&lang=js"
export * from "./ProjectsBlock.vue?vue&type=script&lang=js"

import "./ProjectsBlock.vue?vue&type=style&index=0&id=3b21ff87&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b21ff87"]])

export default __exports__